import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { ValidatesCertificateComponent } from "./validates-certificate.component";

export const routes: Routes = [
    {
        path: ":id",
        component: ValidatesCertificateComponent
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class ValidatesCertificateRoutingModule {}
